export enum GroupType {
  Default = 'default',
  Class = 'class',
  MarkingGroup = 'markingGroup'
}

export type SmallestGroup = {
  name: string;
  description?: string;
  year?: string;
  type: GroupType;
};

// Types used for displaying lists of groups and an individual group:
export type GroupUser = API_JSON & {
  order: number;
  user: API_JSON; // Represents the organisation user of the group user.
};
export type GroupWithGroupUsers = SmallestGroup & {
  id: number;
  users: GroupUser[];
};

// Types used for saving a group:
export type PostAndPatchGroupFields = SmallestGroup;

export type PostGroup = PostAndPatchGroupFields & { organisationId: number };
export type PatchGroupData = Partial<PostAndPatchGroupFields> & { organisationId?: number };
export type PatchGroup = {
  id: number;
  data: PatchGroupData;
};
